export const CreateCurriculumStepsBuckets = {
  0: [
    'gender.id',
    'name',
    'surname',
    'position_name',
    'title_before',
    'title_after',
    'email',
    'phone',
    'address',
    'street_number',
    'city',
    'postcode',
    'country',
    'categories',
  ],
  1: ['curriculum_file', 'certificate_description', 'motivation_letter_description'],
  2: ['image', 'video_file'],
  3: ['experiences'],
  4: ['educations'],
  5: ['skills'],
  6: ['languages'],
  7: [],
};
